import { useEffect, useState } from "./hooks";
// import { createBatch } from "../utils/utils";

type ChangeNotifierListener = <T>(data?: T) => void;

export interface Listenable {
  subscribe(listener: ChangeNotifierListener): void;
  unsubscribe(listener: ChangeNotifierListener): void;
  notify<T>(data?: T): void;
}

// interface AdvancedListenable extends Listenable {
//   has(listener: ChangeNotifierListener): boolean;
// }

// interface IChangeNotifier extends AdvancedListenable {
//   dispose(): void;
//   get _ref(): number;
// }

// function createNotifier(): IChangeNotifier {
//   const subscribers: ChangeNotifierListener[] = [];

//   const batch = createBatch();
//   const listenable = createListenable();

//   return {
//     ...listenable,
//     get _ref() {
//       return batch._ref;
//     },

//     has(listener: ChangeNotifierListener) {
//       return subscribers.includes(listener);
//     },

//     dispose() {
//       subscribers.length = 0;
//       length = 0;
//     },
//   };
// }

export function createListenable(): Listenable {
  const subscribers: ChangeNotifierListener[] = [];
  let length: number = 0;

  return {
    subscribe(listener: ChangeNotifierListener) {
      subscribers.push(listener);
      length++;
    },

    unsubscribe(listener: ChangeNotifierListener) {
      const index = subscribers.indexOf(listener);
      if (index > -1) {
        subscribers.splice(index, 1);
        length--;
      }
    },

    notify<T>(data?: T) {
      for (let i = 0; i < length; i++) {
        subscribers[i](data);
      }
    },
  };
}

// function createValueNotifier<T>(defaultValue: T) {
//   const notifier = createListenable();
//   let _state = defaultValue;
//   const context = {
//     ...notifier,
//     get state(): T {
//       return _state;
//     },

//     set state(newState: T) {
//       if (_state === newState) return;
//       _state = newState;
//       notifier.notify(newState);
//     },
//   };
//   return context;
// }

// interface IController extends Listenable {
//   onInit(): void;
//   onUpdate(): void;
//   onClose(): void;
// }

// export function instanceOfController(dep: any): dep is IController {
//   return dep.onInit && dep.onUpdate && dep.onClose;
// }

export function useListenable<T extends Listenable>(
  listenable: T,
  dispose?: () => void
): T {
  const setState = useState(undefined)[1];
  const updateTarget: ChangeNotifierListener = () => {
    setState(undefined);
  };

  useEffect(() => {
    // if (instanceOfGetLifeCicle(listenable)) {
    //   listenable.onStart();
    // }

    listenable.subscribe(updateTarget);
    return () => {
      //   if (instanceOfGetLifeCicle(listenable)) {
      //     listenable.onClose();
      //     if (dispose != null) {
      //       dispose();
      //     }
      //   }
      return listenable.unsubscribe(updateTarget);
    };
  }, []);

  return listenable;
}
